import { render, staticRenderFns } from "./DataIList.vue?vue&type=template&id=61d2de99&scoped=true"
import script from "./DataIList.vue?vue&type=script&lang=js"
export * from "./DataIList.vue?vue&type=script&lang=js"
import style0 from "./DataIList.vue?vue&type=style&index=0&id=61d2de99&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d2de99",
  null
  
)

export default component.exports